export default "__VITE_ASSET__Wjp0fbUj__"